import { CheckWithoutCircleSvg } from '../svg/check-without-circle-svg'
import { Lang } from '../../translations/lang'

export const AlreadyIcon = () => (
  <div className="flex flex-col items-center gap-[4px]">
    <CheckWithoutCircleSvg />
    <p className="font-bold text-xs text-vixell-green">{Lang.already}</p>
  </div>
)
